import {
  Box,
  CardContent,
  CardHeader,
  Chip,
  Icon,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  IconArchive,
  IconChevronRight,
  IconCloudUpload,
  IconFileSearch,
  IconZoomCheck,
} from "@tabler/icons-react";
import Blink from "../../../util/ui/blink";
import FelixCard from "../../../util/ui/felixCard";
import { Link } from "react-router-dom";

export default function Conectar() {
  return (
    <FelixCard className="conexao comecar">
      <CardHeader
        title="Suas notas de corretagem"
        avatar={<IconArchive size={16} />}
      />
      <CardContent>
        <List sx={{ padding: 0 }}>
          <ListItemButton
            key="uploads"
            dense
            disableGutters
            sx={{ borderRadius: 1 }}
            component={Link}
            to="/arquivo#upload"
          >
            <ListItemIcon style={{ minWidth: 40, justifyContent: "center" }}>
              <Blink color="success" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Box display="flex" flexDirection="row" alignItems="center">
                  <Chip
                    color="primary"
                    icon={<IconCloudUpload />}
                    size="medium"
                    label="Importar arquivos"
                  />
                  <Box flexGrow={1} />
                  <Icon color="action">
                    <IconChevronRight />
                  </Icon>
                </Box>
              }
            />
          </ListItemButton>
          <ListItemButton
            key="notas"
            dense
            disableGutters
            sx={{ borderRadius: 1 }}
            component={Link}
            to="/arquivo#notas"
          >
            <ListItemIcon style={{ minWidth: 40, justifyContent: "center" }}>
              <Blink color="success" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Box display="flex" flexDirection="row" alignItems="center">
                  <Chip
                    color="primary"
                    icon={<IconFileSearch />}
                    size="medium"
                    label="Ver Notas de Corretagem"
                  />
                  <Box flexGrow={1} />
                  <Icon color="action">
                    <IconChevronRight />
                  </Icon>
                </Box>
              }
            />
          </ListItemButton>
          <ListItemButton
            key="consulta"
            dense
            disableGutters
            sx={{ borderRadius: 1 }}
            component={Link}
            to="/consulta"
          >
            <ListItemIcon style={{ minWidth: 40, justifyContent: "center" }}>
              <Blink color="success" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Box display="flex" flexDirection="row" alignItems="center">
                  <Chip
                    color="primary"
                    icon={<IconZoomCheck />}
                    size="medium"
                    label="Consultar ativo"
                  />
                  <Box flexGrow={1} />
                  <Icon color="action">
                    <IconChevronRight />
                  </Icon>
                </Box>
              }
            />
          </ListItemButton>
        </List>
      </CardContent>
    </FelixCard>
  );
}
